import { useMemo, useRef } from 'react';

import { sha256 } from '../gql/utils/sha256';

export type QueryHashRef = ReturnType<typeof useGqlQueryHashRef>;

const useHashPromise = (ref: QueryHashRef, query: string) =>
  useMemo(async () => {
    if (ref.current) {
      ref.current.query = query;
      ref.current.hash = '';
    }
    const hashedQuery = await sha256(query);
    if (ref.current && ref.current.query === query) {
      ref.current.hash = hashedQuery;
    }

    return hashedQuery;
  }, [query]);

export const useGqlQueryHashRef = (query: string) => {
  const ref = useRef({
    query,
    hash: '',
    hashPromise: Promise.resolve(''),
  });

  const hashPromise = useHashPromise(ref, query);

  if (ref.current) {
    ref.current.hashPromise = hashPromise;
  }

  return ref;
};
